import { storage } from "../firebase";
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";

export const uploadMediaToServer = async (media, staticPath = "null") => {
  try {
    if (!media) return "";

    // Generate unique filename with timestamp
    const fileName = `${Date.now()}_${media.name || "file"}`;
    const subFolder =
      staticPath && staticPath !== "null" ? staticPath : "uploads";
    const folderPath = `tanushree/${subFolder}`;

    // Create Firebase Storage Reference under tanushree folder
    const storageRef = ref(storage, `${folderPath}/${fileName}`);

    // Upload file bytes to Firebase Storage
    const snapshot = await uploadBytes(storageRef, media);

    // Get public downloadable URL
    const downloadUrl = await getDownloadURL(snapshot.ref);

    return downloadUrl;
  } catch (e) {
    console.error("Firebase Storage upload error:", e);
    alert(e?.message || "Failed to upload file to Firebase Storage");
    throw e;
  }
};
